import { useQuery } from 'react-query';

import { getCombinedSRBMChartData } from 'api/traps/SRBMTraps/getCombinedSRBMChartData';

export const useGetCombinedSRBMChartData = (slug: string, isPercents: boolean) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    'CombinedSRBMChartData',
    () => getCombinedSRBMChartData(slug, isPercents),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetCombinedSRBMChartData;
